import { ICheckoutComponent } from '@hotelplan/components.common.checkout';
import { OrlCheckoutFragment } from 'graphql/orl/ORLCheckout.generated';
import FlightItem from './offerItem/FlightItem';
import { mapOrlFlightToIFlightSectionProps } from './Orl.mappers';

export function normalizeCheckoutComponent(
  checkout: OrlCheckoutFragment
): ICheckoutComponent {
  const { priceChanged, flightChanged, changedOffer } = checkout;
  const inFlight = changedOffer?.inboundFlight;
  const outFlight = changedOffer?.outboundFlight;

  const inboundFlight = inFlight
    ? mapOrlFlightToIFlightSectionProps(inFlight)
    : null;
  const outboundFlight = outFlight
    ? mapOrlFlightToIFlightSectionProps(outFlight)
    : null;

  return {
    priceChanged,
    flightChanged,
    price: changedOffer?.totalPrice.amount,
    flightChangedComponent: (
      <>
        {outboundFlight && <FlightItem {...outboundFlight} />}
        {inboundFlight && <FlightItem {...inboundFlight} isReturnFlight />}
      </>
    ),
  };
}
